import type { IToastState } from '@/api/model/chatType'

export const TOAST_MESSAGE: Record<IToastState, string> = {
  createMissionComplete: '미션 생성 완료🎉',
  switchChitchatFailed: '주제 변경 실패',
  switchChitchatSuccess: '상담이 자유 상담으로 전환되었습니다. ',
  exitFailed: '채팅 종료에 실패했습니다. 잠시 후 다시 시도해주세요.',
  feedbackFailed: '피드백 생성 실패'
}

export const TOPIC_PREPARING_MESSAGE = '준비중입니다!'
